export default "ALTER TABLE `recurring_transactions` ADD `notes` text;--> statement-breakpoint\nALTER TABLE `recurring_transactions` ADD `time` text;";